var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { fadeInAnimation } from '@/admin-ui/custom-pages/CustomPagesTable';
import _ from 'lodash';
import styled from 'styled-components';
/**
 *
 * @example
 * <Grid areas={['header', 'main', 'footer']} columns="1fr 3fr 1fr" rows="auto 1fr auto" gap="16px">
 *     <GridItem area="header">
 *         <div>Header Content</div>
 *     </GridItem>
 *     <GridItem.Flex area="main" gap="10px" justify="center" align="stretch">
 *         <div>Main Content</div>
 *     </GridItem.Flex>
 *     <GridItem area="footer">
 *         <div>Footer Content</div>
 *     </GridItem>
 * </Grid>
 *
 */
export var Grid = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: grid;\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n"], ["\n    display: grid;\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n"])), function (_a) {
    var areas = _a.areas;
    return areas && "grid-template-areas: ".concat(_.map(areas, function (area) { return "\"".concat(area, "\""); }).join(' '), ";");
}, function (_a) {
    var columns = _a.columns;
    return columns && "grid-template-columns: ".concat(columns, ";");
}, function (_a) {
    var rows = _a.rows;
    return rows && "grid-template-rows: ".concat(rows, ";");
}, function (_a) {
    var gap = _a.gap;
    return gap && "gap: ".concat(gap, ";");
}, function (_a) {
    var height = _a.height;
    return height && "height: ".concat(height, ";");
}, function (_a) {
    var overflow = _a.overflow;
    return overflow && "overflow: ".concat(overflow, ";");
}, function (_a) {
    var withFadeIn = _a.withFadeIn;
    return withFadeIn && fadeInAnimation;
});
var templateObject_1;
